module.exports = __webpack_public_path__ + "static/media/049.c2b94c38.jpg";